export function PageContainer({ children }: { children: React.ReactNode }) {
  return <div className="space-y-6 p-4 md:p-6 max-w-5xl mx-auto">{children}</div>;
}
